import { Component } from '@angular/core';

@Component({
	selector: 'dashboard-page',
	templateUrl: './dashboard.html',
	styleUrls: ['./dashboard.css']
})
export class DashBoardPage {
	public constructor() {}
}


// WEBPACK FOOTER //
// ./src/pages/dashboard/dashboard.ts